(() => {
  if (window.__productGalleryArrowsInit) return;
  window.__productGalleryArrowsInit = true;

  const goTo = (carousel, direction) => {
    const thumbs = [...carousel.querySelectorAll('[data-desktop-pager] button')];
    if (!thumbs.length) return;

    const current = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('active')));
    const target = (current + direction + thumbs.length) % thumbs.length;

    thumbs[target].click();
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!arrow) return;

    const carousel = arrow.closest('site-carousel');
    if (!carousel) return;

    event.preventDefault();
    goTo(carousel, arrow.hasAttribute('data-gallery-prev') ? -1 : 1);
  });
})();
